import React from 'react';

import Table, {
    TableFooter,
    TablePagination,
    TableRow,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';

import List, {ListItem, ListItemText} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';

import {Add, Flight, Adjust} from 'material-ui-icons';

import Editation from './Editation';

import tsl from './../../../tsl';
import axios from 'axios';

class AircraftList extends React.Component {

	state = {
        rowsPerPage: 10,
        page: 0,
        total: 0,
        data: [],
        entity: {},
        formDisplay: false
    };

	componentDidMount() {
		this.loadAircrafts(1);
	}

	loadAircrafts(page) {
		axios.get('/api/operator/aircraft/models?page=' + page + '&perPage=' + this.state.rowsPerPage)
			.then((response) => {
				//console.log(response.data);
				this.setState({
					data: response.data.data,
					page: response.data.current_page,
					total: response.data.total,
					rowsPerPage: parseInt(response.data.per_page),
					//entity: response.data.data[0]
				});
			});
	}

	handleChangePage(e, page) {
		this.loadAircrafts(page+1);	// paginator counts pages as indexes (starting 0)
	}

	handleClick(model) {
		this.setState({
			entity: model,
            formDisplay: true,
		});
        // TODO: Focus to editation form
	}

	saveEntity = (model) => {
		if (!model.files) {
			model.files = [];	// when 
		}
        if (!model.aircrafts) {
            model.aircrafts = [];
        }
		axios.post('/api/operator/aircraft/models' + (model.id ? '/'+model.id : ''), model)
			.then((response) => {
                // feedback manager by request interceptors (success - proces continues, and user see results, failure - axios error)
                this.setState({
                    entity: {},
                    formDisplay: false
                });
                this.loadAircrafts(this.state.page);
			});
	}

    deleteEntity = (model) => {
        axios.delete('/api/operator/aircraft/models/' + model.id)
            .then(res => {
                this.setState({
                    entity: {},
                    formDisplay: false
                });
                this.loadAircrafts(this.state.page);
            });
    }

    createNew = () => {
        this.setState({
            entity: { files: [] },
            formDisplay: true
        });
        // TODO: Focus to editation form
    }

    handleCloseForm = () => {
        this.setState({
            entity: null,
            formDisplay: false,
        });
    }

    render() {
    	return (
    	<div>
        		
    		<div style={this.state.formDisplay ? {} : {display: "none"}}>
        		<Editation 
                    ref="editationForm"
                    entityData={this.state.entity ? this.state.entity : {}} 
                    saveEntity={this.saveEntity}
                    deleteEntity={this.deleteEntity}
                    onClose={this.handleCloseForm} />
    		</div>

            {this.state.formDisplay ? '' : 

            <div>
                <Button raised fab color="accent" 
                    className="jr-fab-btn text-white"
                    style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                    onClick={this.createNew}
                >
                    <Add />
                </Button>          

                <Paper>
                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <List>
                                {this.state.data.map((model, index) => {
                                    let secondaryInfo = [];
                                    
                                    const aircraftsCount = model.aircrafts ? model.aircrafts.length : 0;
                                    secondaryInfo.push(
                                            tsl('aircrafts.list.count_in_fleet', {count: aircraftsCount})
                                        );

                                    /*
                                    if (model.range) 
                                        secondaryInfo.push(
                                            tsl('aircrafts.list.model_range', {range: model.range})
                                        );

                                    if (model.passengers_capacity) 
                                        secondaryInfo.push(
                                            tsl('aircrafts.list.model_capacity', {capacity: model.passengers_capacity})
                                        );
                                    */
                                    
                                    return (
                                        <div key={model.id}>
                                            <ListItem button
                                                onClick={(e) => {this.handleClick(model)}}
                                            >
                                                <Avatar style={{color: 'lightblue', backgroundColor: 'white'}}>
                                                    {model.type.id == 1 ? <Flight /> : <Adjust />}
                                                </Avatar>
                                                <ListItemText className="br-break"
                                                    primary={model.name}
                                                    secondary={secondaryInfo.join(", ")}
                                                />
                                            </ListItem>
                                            <Divider light />
                                        </div>
                                    );
                                })}
                            </List>

                            <Table className="">
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={this.state.total}
                                            rowsPerPage={this.state.rowsPerPage}
                                            rowsPerPageOptions={[this.state.rowsPerPage]}
                                            page={this.state.page-1}
                                            onChangePage={(e, page) => {this.handleChangePage(e, page)}}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
            	</Paper>
            </div>
            
            }

        </div>
        );
    }
}

export default AircraftList;


// WEBPACK FOOTER //
// ./app/used/aircrafts/routes/List.js